function fetchConfig(type = 'json', contentType = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': `application/${contentType}`, Accept: `application/${type}` },
  }
}

// Set browser language
function setBrowserLanguage() {
  let currentLanguage = navigator.language || Navigation.userLanguage || 'EN'
  currentLanguage = currentLanguage.toUpperCase()

  const body = JSON.stringify({
    attributes: {
      browser_language: currentLanguage,
    },
  })

  fetch('/cart/update.js', { ...fetchConfig(), ...{ body } }).catch((error) => {
    console.log('Error setting browser language', error)
  })
}
// Check if browser language needs to be set
const setBrowserLanguageElement = document.querySelector('[data-set-browser-language]')
if (setBrowserLanguageElement) {
  setBrowserLanguage()
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  )
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event?.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach((video) => video.pause())
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause())
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)))
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent)
    }
  }
}

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput)
}

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

const serializeForm = (form) => {
  const obj = {}
  const formData = new FormData(form)
  for (const key of formData.keys()) {
    obj[key] = formData.get(key)
  }
  return JSON.stringify(obj)
}

function getNodeIndex(node) {
  return Array.from(node.parentNode.children).indexOf(node)
}

// Hover/touch effect on collection page product cards
const productCards = document.querySelectorAll('.product-card-wrapper')
if (productCards) {
  productCards.forEach((productCard) => {
    productCard.ontouchstart = function () {
      productCards.forEach((productCard) => productCard.classList.remove('hover'))
      this.classList.add('hover')
    }
  })
}

// Show chat button based on availability from app
const chatInterval = window.setInterval(function () {
  if (window.RichpanelAppProxy && window.RichpanelAppProxy.messengerConfiguration.messengerStatus) {
    window.clearInterval(chatInterval) // this line breaks out of the loop - make sure it's not deleted.
    // the list of supported events is detailed below
    document.querySelectorAll('[data-chat-icon]').forEach((chatIcon) => {
      chatIcon.classList.remove('visually-hidden')
    })
  }
}, 200)
window.setTimeout(function () {
  // Destroy the chat interval after 5 seconds if needed
  if (chatInterval) {
    window.clearInterval(chatInterval)
  }
}, 8000)

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid)

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this))

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt2 = document.createElement('option')
        opt2.value = provinces[i][0]
        opt2.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt2)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

function renderSection(sectionName, async) {
  const request = new XMLHttpRequest()
  return new Promise(function (resolve, reject) {
    request.onreadystatechange = function () {
      if (request.readyState == 4) {
        if (request.status >= 300) {
          reject(`Error while getting ${sectionName}, status code = ${request.status}`)
        } else {
          resolve(request)
        }
      }
    }
    request.open('GET', `/?sections=${sectionName}`, async)
    request.send()
  })
}

var screenIsMobile
var mobileMenuLoaded = false
var desktopMenuLoaded = false

function setMobileMenu() {
  if (!mobileMenuLoaded) {
    document.querySelector('[data-header-menu-desktop-skeleton]').setAttribute('hidden', true)
    renderSection('header-menu-mobile', false).then((res) => {
      document.querySelector(`[data-header-menu-mobile]`).innerHTML = JSON.parse(res.responseText)['header-menu-mobile']
      renderSection('header-menu-mobile-toggle', document.querySelector(`[data-header-menu-mobile-toggle]`), true).then((res) => {
        document.querySelector(`[data-header-menu-mobile-toggle]`).innerHTML = JSON.parse(res.responseText)['header-menu-mobile-toggle']
        document.querySelector('[data-header-menu-mobile-placeholder]').setAttribute('hidden', true)
        mobileMenuLoaded = true
      })
    })
  }
  screenIsMobile = true
  document.querySelector('[data-header-menu-desktop]').setAttribute('hidden', true)
}

function setDesktopMenu() {
  const container = document.querySelector('[data-header-menu-desktop]')
  if (!desktopMenuLoaded) {
    renderSection('header-menu-desktop', container, true).then((res, error) => {
      if (res) {
        const section = JSON.parse(res.responseText)['header-menu-desktop']
        if (section) {
          document.querySelector('[data-header-menu-desktop-skeleton]').setAttribute('hidden', true)
          container.innerHTML = section
          container.classList.toggle('fade')
          desktopMenuLoaded = true
        }
      }
      if (error) {
        console.error(error)
      }
    })
  }
  screenIsMobile = false
  container.removeAttribute('hidden')
}

addEventListener('resize', (event) => {
  if (event.currentTarget.innerWidth < 1200 && !screenIsMobile) {
    setMobileMenu()
  } else if (event.currentTarget.innerWidth > 1200 && screenIsMobile) {
    setDesktopMenu()
  }
})

window.innerWidth < 1200 ? setMobileMenu() : setDesktopMenu()
